import { Badge } from "@/components/ui/badge";

const COLORS = {
  New: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
  "Under Review": "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  "Call Pending": "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  Verified: "bg-teal-500/15 text-teal-600 dark:text-teal-400",
  Objection: "bg-orange-500/15 text-orange-600 dark:text-orange-400",
  Approved: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  "Pending Down Payment": "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  Rejected: "bg-red-500/15 text-red-600 dark:text-red-400",
  Cancelled: "bg-zinc-500/15 text-zinc-600 dark:text-zinc-400",
  Converted: "bg-primary/15 text-primary",
  Pending: "bg-zinc-500/15 text-zinc-600 dark:text-zinc-400",
  Processing: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
  "Ready for Delivery": "bg-indigo-500/15 text-indigo-600 dark:text-indigo-400",
  Dispatched: "bg-violet-500/15 text-violet-600 dark:text-violet-400",
  "Out for Delivery": "bg-violet-500/15 text-violet-600 dark:text-violet-400",
  Delivered: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  "Active Installment": "bg-teal-500/15 text-teal-600 dark:text-teal-400",
  Completed: "bg-emerald-600/15 text-emerald-700 dark:text-emerald-400",
  Open: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
  Assigned: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  "In Progress": "bg-violet-500/15 text-violet-600 dark:text-violet-400",
  Resolved: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  Closed: "bg-zinc-500/15 text-zinc-600 dark:text-zinc-400",
};

export default function StatusBadge({ status }) {
  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${COLORS[status] || "bg-secondary text-foreground"}`}>{status}</span>;
}

export const ORDER_FLOW = ["Pending Down Payment", "Approved", "Processing", "Ready for Delivery", "Dispatched", "Out for Delivery", "Delivered", "Active Installment", "Completed"];
